'use client';

import { createTheme, ThemeOptions } from '@mui/material/styles';
import responsiveBaseTheme from '@/styles/brands/base';
import deepmerge from '@mui/utils/deepmerge';

const wv_us = createTheme(
	deepmerge(responsiveBaseTheme, {
		palette: {
			primary: {
				main: 'rgba(20, 19, 16, 1)', // #141310
			},
			secondary: {
				main: 'rgba(215, 9, 38, 1)', // #D70926
			},
			accent: {
				main: 'rgba(248, 248, 248, 1)', // #f8f8f8
			},
			lightAccent: {
				main: 'rgba(248, 248, 248, 1)', // #f8f8f8
			},
			lightBackground: {
				main: 'rgba(248, 248, 248, 1)', // #F8F8F8
			},
		},
		components: {
			MuiButton: {
				styleOverrides: {
					contained: () => ({
						boxShadow: 'none',
						'&:hover': {
							backgroundColor: 'rgba(196, 8, 35, 1)', // #c40823
						},
						'&:focus': {
							backgroundColor: 'rgba(153, 6, 27, 1)', // #99061b
						},
						'&:active': {
							backgroundColor: 'rgba(153, 6, 27, 1)', // #99061b
						},
					}),
				},
			},
			MuiFab: {
				styleOverrides: {
					root: {
						boxShadow: 'none',
						'&:hover': {
							backgroundColor: 'rgba(196, 8, 35, 1)', // #c40823
						},
						'&:focus': {
							backgroundColor: 'rgba(153, 6, 27, 1)', // #99061b
						},
						'&:active': {
							backgroundColor: 'rgba(153, 6, 27, 1)', // #99061b
						},
					},
				},
			},
		},
	} as ThemeOptions),
);

export default wv_us;
